import { REQUEST_GIFT_OPTIONS } from 'store/ducks/giftoptions/types';

export const fetchGiftOptions = () => ({ type: REQUEST_GIFT_OPTIONS });
